import { render, staticRenderFns } from "./peopleSystem.vue?vue&type=template&id=8ef2b896&scoped=true&"
import script from "./peopleSystem.vue?vue&type=script&lang=js&"
export * from "./peopleSystem.vue?vue&type=script&lang=js&"
import style0 from "./peopleSystem.vue?vue&type=style&index=0&id=8ef2b896&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef2b896",
  null
  
)

export default component.exports